module.exports = __webpack_public_path__ + "static/media/conference.ef6d92af.svg";